import Privacy from 'src/app/Privacy/Privacy'

export default Privacy
